import { number, object, string } from 'yup';

export const redirectFormValidationSchema = object().shape({
  pluginMetadata: object().shape({
    url: string().required('Target URL is required').url('Must be a valid URL'),
    secondsToClaim: number().required('Seconds to claim is required')
  })
});
